import MaterialTable from 'material-table';
import React from 'react';

// import EditIcon from '../../icons/Edit.png';

const DeliveryOptionsTable = ({ currentUser, deliveryOptions, toggleActive, history }) => {
    const actions = [];
    if (currentUser.permissions.includes('deliveryoptions--update')) {
        actions.push({
            icon: 'edit',
            tooltip: 'Edit Delivery Method',
            onClick: (e, deliveryOption) => history.replace(`/delivery/${deliveryOption.ID}`),
        });
    }

    const getDeliveryOptionByID = id =>
        deliveryOptions.filter(({ ID: deliveryOptionID }) => deliveryOptionID === id);

    const toggleDeliveryOptionActiveStatus = ({ ID }) => {
        const foundDelivery = getDeliveryOptionByID(ID);
        if (!foundDelivery.length) return;
        toggleActive(foundDelivery.pop());
    };

    const __renderStatusBtn = ({ ID, active }) => {
        let className = '',
            displayText = '',
            bkgColor = '';

        const styles = {
            bkgColorAquaMarine: {
                backgroundColor: '#4bd4b0',
            },
            bkgColorDustyMarine: {
                backgroundColor: '#ff6633',
            },
            bkgColorBlue: {
                backgroundColor: '#65abe9',
            },
            statusBtn: {
                width: 168,
                height: 20,
                borderRadius: 15,
                fontSize: 10,
                letterSpacing: 2,
                color: '#fff',
                border: 'none',
                backgroundColor: '#535a6b',
                lineHeight: 1,
                fontWeight: 'bold',
            },
            circle: {
                width: 10,
                height: 10,
                borderRadius: 10,
                float: 'left',
                clear: 'left',
                marginRight: 7,
                marginLeft: -7,
            },
        };

        if (active === undefined || active === false) {
            bkgColor = styles.bkgColorDustyMarine;
            displayText = 'inactive';
            className = 'danger';
        } else {
            bkgColor = styles.bkgColorAquaMarine;
            displayText = 'active';
            className = 'primary';
        }

        return (
            <button
                className={`btn btn-${className}`}
                style={styles.statusBtn}
                onClick={e => toggleDeliveryOptionActiveStatus({ ID })}
            >
                <div className="float-left">
                    <div style={{ ...styles.circle, ...bkgColor }} />
                    {displayText.toUpperCase()}
                </div>
            </button>
        );
    };

    const __handleStoreText = store => {
        let result;
        switch (store) {
            case 'blacks':
                result = 'Blacks';
                break;
            case 'footpatrol':
                result = 'Footpatrol';
                break;
            case 'jdplc':
                result = 'JD PLC';
                break;
            case 'jdsports':
                result = 'JD Sports';
                break;
            case 'millets':
                result = 'Millets';
                break;
            case 'scotts':
                result = 'Scotts';
                break;
            case 'size':
                result = 'size?';
                break;
            case 'tessuti':
                result = 'Tessuti';
                break;
            case 'ultimateoutdoors':
                result = 'Ultimate Outdoors';
                break;
            default:
                result = '';
                break;
        }
        return result;
    };

    return (
        <div className="table-wrapper">
            <MaterialTable
                title=""
                columns={[
                    {
                        title: 'STORE',
                        field: 'store',
                        render: store => __handleStoreText(store),
                        searchable: true,
                        defaultGroupOrder: 0,
                    },
                    {
                        title: 'CARRIER CODE',
                        field: 'carrierCode',
                        searchable: true,
                    },
                    {
                        title: 'NAME',
                        field: 'name',
                        searchable: true,
                    },
                    {
                        title: 'PRICE',
                        field: 'price',
                        searchable: true,
                        render: ({ price }) => `£${price}`,
                    },
                    {
                        title: 'DESCRIPTION',
                        field: 'description',
                        searchable: true,
                    },
                    {
                        title: 'CHANNEL',
                        field: 'channel',
                        searchable: true,
                        render: ({ channels }) => `${channels.join(', ')}`,
                    },
                    {
                        title: 'STATUS',
                        field: 'status',
                        render: deliveryOption => __renderStatusBtn(deliveryOption),
                        sorting: false,
                    },
                ]}
                data={deliveryOptions}
                actions={actions}
                options={{
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    sorting: true,
                }}
            />
        </div>
    );
};

export default DeliveryOptionsTable;
